import { useEffect, useState, memo } from "react";
import { OverlayView } from "@react-google-maps/api";
import { IoLocationSharp } from "react-icons/io5";

interface CurrentLocationMarkerProps {
  position: { lat: number; lng: number };
}

const getPixelPositionOffset = () => ({
  x: -32,
  y: -32,
});

export const CurrentLocationMarker = memo(
  ({ position }: CurrentLocationMarkerProps) => {
    const [address, setAddress] = useState<string>("Obtendo endereço...");

    useEffect(() => {
      // Verificar se o Google Maps está carregado
      if (typeof google === "undefined" || !google.maps) {
        console.log("Google Maps ainda não carregado");
        return;
      }

      // Geocoding reverso para obter o endereço
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: position }, (results, status) => {
        console.log("Geocoding status:", status);
        console.log("Geocoding results:", results);

        if (status === "OK" && results && results[0]) {
          // Extrair rua e número (primeiras duas partes)
          const fullAddress = results[0].formatted_address;
          const parts = fullAddress.split(",");
          const streetAddress = parts.slice(0, 2).join(",").trim();
          setAddress(streetAddress);
        } else {
          console.error("Erro no geocoding:", status);
          setAddress("Endereço não encontrado");
        }
      });
    }, [position]);

    return (
      <OverlayView
        position={position}
        mapPaneName={OverlayView.OVERLAY_LAYER}
        getPixelPositionOffset={getPixelPositionOffset}
      >
        <div
          className="relative flex flex-col items-center pointer-events-none"
          style={{ width: "64px", height: "64px" }}
        >
          {/* Círculo pulsante externo */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 bg-[hsl(var(--primary))]/20 rounded-full animate-ping" />
          </div>

          {/* Marcador principal */}
          <div className="relative z-10 w-16 h-16 bg-[hsl(var(--primary))] rounded-full flex items-center justify-center shadow-lg shadow-[hsl(var(--primary))]/30">
            <IoLocationSharp className="text-white text-3xl" />
          </div>

          {/* Card com endereço */}
          <div className="absolute top-full mt-4 left-1/2 -translate-x-1/2 px-4 py-2 rounded-xl bg-white/90 backdrop-blur-sm shadow-lg min-w-[200px] max-w-[350px] whitespace-nowrap pointer-events-auto">
            <p className="text-xs font-semibold text-[hsl(var(--primary))] text-center mb-1">
              📍 Você está aqui
            </p>
            <p className="text-sm text-gray-900 text-center font-medium">
              {address}
            </p>
          </div>
        </div>
      </OverlayView>
    );
  },
);
